import { render, staticRenderFns } from "./LabelForm.vue?vue&type=template&id=a7668ac0&scoped=true&"
import script from "./LabelForm.vue?vue&type=script&lang=js&"
export * from "./LabelForm.vue?vue&type=script&lang=js&"
import style0 from "./LabelForm.vue?vue&type=style&index=0&id=a7668ac0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7668ac0",
  null
  
)

export default component.exports